import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';
import { useTheme } from '../context/ThemeContext';

const AccessibilityPage = () => {
  const { isDarkMode } = useTheme();

  return (
    <Box
      component="main"
      id="main-content"
      tabIndex="-1"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: theme => theme.palette.background.default,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          component="h1"
          gutterBottom
          sx={{
            mb: 4,
            fontWeight: 700,
            background: 'linear-gradient(45deg, #2E5BFF, #00C896)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Accessibility Statement
        </Typography>

        <Paper
          elevation={2}
          sx={{
            p: 4,
            borderRadius: 2,
            backgroundColor: isDarkMode ? 'background.paper' : 'background.paper',
          }}
        >
          <Typography variant="h5" component="h2" gutterBottom fontWeight={600}>
            Our Commitment to Accessibility
          </Typography>
          
          <Typography variant="body1" paragraph>
            ITFORSEC is committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone and applying the relevant accessibility standards.
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            Conformance Status
          </Typography>
          
          <Typography variant="body1" paragraph>
            The Web Content Accessibility Guidelines (WCAG) defines requirements for designers and developers to improve accessibility for people with disabilities. It defines three levels of conformance: Level A, Level AA, and Level AAA. ITFORSEC is partially conformant with WCAG 2.1 level AA. Partially conformant means that some parts of the content do not fully conform to the accessibility standard.
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            Accessibility Features
          </Typography>
          
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>Keyboard navigation support</li>
            <li>Color contrast compliance</li>
            <li>Text resizing without loss of content or functionality</li>
            <li>Alternative text for images</li>
            <li>ARIA landmarks and roles</li>
            <li>Focus indicators for interactive elements</li>
            <li>Skip to content functionality (Alt+1)</li>
            <li>Skip to navigation functionality (Alt+2)</li>
          </Typography>
          
          <Typography variant="h6" component="h3" gutterBottom fontWeight={600} sx={{ mt: 4 }}>
            Feedback
          </Typography>
          
          <Typography variant="body1" paragraph>
            We welcome your feedback on the accessibility of ITFORSEC. Please let us know if you encounter accessibility barriers on our website by emailing info@itforsec.com.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default AccessibilityPage;
